import { createContext } from 'react';

const TokenContext = createContext();

export const TokenContextProvider = TokenContext.Provider;

export default TokenContext;
